import { createFileRoute } from '@tanstack/react-router'

import { QuoteDetail } from '@/components/quotes/quote-detail'
import { parseQuoteStepSearch } from '@/components/quotes/quote-steps'

/** Fiche d'une soumission, ouverte par son numéro (« SO-2026-0042 ») ou son identifiant ; `etape` pour un brouillon. */
export const Route = createFileRoute('/_app/quotes/$quoteNumber')({
  validateSearch: parseQuoteStepSearch,
  component: QuoteDetailPage,
})

function QuoteDetailPage() {
  const { quoteNumber } = Route.useParams()
  const { etape } = Route.useSearch()
  const navigate = Route.useNavigate()
  return (
    <QuoteDetail
      quoteNumber={quoteNumber}
      step={etape ?? 'generalites'}
      onStepChange={(step) => {
        void navigate({ search: (current) => ({ ...current, etape: step }), replace: true })
      }}
    />
  )
}
